import { Message } from "element-ui";
import { icons } from "./logo";

class EventEmitter {
    constructor() {
        this.listeners = {}
        this.state = {
            modals: [
                // {
                //     id: 1661071391015,
                //     name: '员工折线图',
                //     icon: 'icon-bar_d_chart',
                //     color: '#409EFF',
                //     size: null,
                //     component: 'linechart',
                //     optionName: 'linechart_1661068229790'
                // }
            ],
            comps: {
                linechart: () => import('../charts/linechart'),
                histogram: () => import('../charts/histogram'),
                piechart: () => import('../charts/piechart'),
                website: () => import('../charts/website'),
            },
            modules: [
                {
                    id: 1,
                    name: "折线图",
                    compName: "linechart",
                    url: "https://bingloe.shop/file/images/charts/linechart.png",
                    format: "https://bingloe.shop/file/images/excels/lineExcel.xlsx"
                },
                {
                    id: 2,
                    name: "柱状图",
                    compName: "histogram",
                    url: "https://bingloe.shop/file/images/charts/histogram.png",
                    format: "https://bingloe.shop/file/images/excels/histogramExcel.xlsx"
                },
                {
                    id: 3,
                    name: "饼图",
                    compName: "piechart",
                    url: "https://bingloe.shop/file/images/charts/piechart.png",
                    format: "https://bingloe.shop/file/images/excels/pieExcel.xlsx"
                },
                {
                    id: 4,
                    name: "网站",
                    compName: "website",
                    url: "https://bingloe.shop/file/images/charts/website.jpeg",
                    format: false
                }
            ],
            logos: icons,
            options: {
                // "linechart_1661068229790": {
                //     "title": {
                //         "text": "测试图"
                //     },
                //     "toolbox": {
                //         "feature": {
                //             "saveAsImage": {}
                //         }
                //     },
                //     "legend": {},
                //     "xAxis": {},
                //     "yAxis": {},
                //     "series": [
                //         {
                //             "smooth": true,
                //             "areaStyle": {},
                //             "label": {
                //                 "show": true,
                //                 "position": "top"
                //             }
                //         },
                //         {
                //             "smooth": true,
                //             "areaStyle": {},
                //             "label": {
                //                 "show": true,
                //                 "position": "top"
                //             }
                //         }
                //     ]
                // }
            }
        }
    }

    /**
     * 数组添加子元素
     * @param {*} name 
     * @param {*} value 
     */
    addChild(name, value) {
        if (this.state[name].constructor === Array) {
            this.state[name].push(value)
        } else {
            Message({
                message: "非数组类型，禁止添加！",
                type: "error",
                duration: 3000
            });
        }
    }

    /**
     * 数组删除子元素
     * @param {*} name 
     * @param {*} attr 
     * @param {*} value 
     */
    delChild(name, attr, value) {
        if (this.state[name].constructor === Array) {
            this.state[name] = this.state[name].filter(item => item[attr] !== value)
        } else {
            Message({
                message: "非数组类型，禁止删除！",
                type: "error",
                duration: 3000
            });
        }
    }

    /**
     * 对象添加子属性
     * @param {*} name 
     * @param {*} attr 
     * @param {*} value 
     */
    addAttr(name, attr, value) {
        if (this.state[name].constructor === Object) {
            this.state[name][attr] = value;
        } else {
            Message({
                message: "非对象类型，禁止添加！",
                type: "error",
                duration: 3000
            });
        }
    }

    /**
     * 对象删除子属性
     * @param {*} name 
     * @param {*} attr 
     */
    delAttr(name, attr) {
        if (this.state[name].constructor === Object) {
            if (this.state[name][attr]) {
                delete this.state[name][attr];
            }
        } else {
            Message({
                message: "非对象类型，禁止删除！",
                type: "error",
                duration: 3000
            });
        }
    }

    /**
     * 设置状态
     * @param {*} name 
     * @param {*} val 
     * @param {*} time_stamp 
     * @returns 
     */
    setter(name, val, time_stamp = false) {
        if (time_stamp) {
            const stamp = String(Date.now())
            this.state[`${name}_${stamp}`] = val
            return stamp
        } else {
            this.state[name] = val
        }
    }

    /**
     * 获取状态
     * @param {*} name 
     * @param {*} stamp 
     * @returns 
     */
    getter(name, stamp) {
        if (stamp) {
            return this.state[`${name}_${stamp}`]
        } else {
            return this.state[name]
        }
    }

    /**
     * 删除状态
     * @param {*} name 
     */
    del(name) {
        if (this.state[name]) {
            delete this.state[name]
        }
    }

    /**
    * 注册事件监听者
    * @param {String} type 事件类型
    * @param {Function} cb 回调函数
    */
    on(type, cb) {
        this.listeners[type] = [] // 重置该任务
        this.listeners[type].push(cb)
    }

    /**
    * 发布事件
    * @param {String} type 事件类型
    * @param  {...any} args 参数列表，把emit传递的参数赋给回调函数
    */
    emit(type, ...args) {
        if (this.listeners[type]) {
            this.listeners[type].forEach(cb => {
                cb(...args)
            })
        }
    }

    /**
    * 移除某个事件的一个监听者
    * @param {String} type 事件类型
    * @param {Function} cb 回调函数
    */
    off(type, cb) {
        if (this.listeners[type]) {
            let n = this.listeners[type].length;
            for (let i = 0; i < n; i++) {
                if (this.listeners[type][i] === cb) {
                    this.listeners[type].splice(i, 1)
                    break;
                }
            }
        }
    }

    /**
    * 移除某个事件的所有监听者
    * @param {String} type 事件类型
    */
    offAll(type) {
        if (this.listeners[type]) {
            delete this.listeners[type]
        }
    }
}

/**
 * 创建闭包实例
 * @returns 
 */
const $pubsub = function () {
    let fn = null;
    return function () {
        if (!fn) {
            fn = new EventEmitter()
            return fn
        } else {
            return fn
        }
    }
}

export default $pubsub();